<app-filter-header title="Filtrar alegaciones" i18n-title (apply)="this.apply()" (reset)="this.reset()" (dismiss)="this.dismiss()"></app-filter-header>
<div class="modal-body">
  <div class="row">
    <app-form-text-edit class="col-sm-3" i18n-label label="Agente" [(value)]="filter.AGENTE" maxLenght="20" number="true"></app-form-text-edit>
    <!-- <app-form-date-edit class="col-sm-3" i18n-label label="Fecha expediente" [(value)]="filter." type="calendar"></app-form-date-edit> -->
    <app-form-date-edit class="col-sm-3" i18n-label label="Fecha de entrada de alegación" [(value)]="filter.DATAPLEC" type="calendar"></app-form-date-edit>
  </div>
</div>